import { frontendURL } from '../../../helper/URLHelper';
import CRMIndex from './pages/CRMIndex.vue';
import CardDetailPage from './pages/CardDetailPage.vue';

const commonMeta = {
  permissions: ['administrator', 'agent', 'custom_role'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm'),
    component: CRMIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'crm_dashboard',
        component: CRMIndex,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL(
      'accounts/:accountId/crm/funnels/:funnelId/cards/:cardId'
    ),
    name: 'crm_card_detail',
    component: CardDetailPage,
    meta: commonMeta,
  },
];
